import React from 'react';
import { Check, InfoOutlined } from '@mui/icons-material';
import { ListItem, Grow, Stack, LinearProgress, Typography, Tooltip, List } from '@mui/material';

var PasswordStrengthProgress = function (_a) {
    var value = _a.value, messages = _a.messages, progress = _a.progress, scoreTranslation = _a.scoreTranslation, scoreColor = _a.scoreColor;
    var color = scoreColor;
    var errorMessages = messages.map(function (message) { return (React.createElement(ListItem, { key: message, sx: { py: 0, pl: 0, display: 'list-item' } }, message)); });
    return (React.createElement(Grow, { in: value.length > 0, style: {
            transformOrigin: 'center left',
        } },
        React.createElement(Stack, { spacing: 1, alignItems: "end" },
            React.createElement(LinearProgress, { variant: "determinate", value: Math.min(progress + value.length, 100) || 0, color: color, sx: {
                    width: '100%',
                    borderRadius: 5,
                    height: value.length > 0 ? 4 : 0,
                    transition: 'height 200',
                    backgroundColor: function (theme) { return theme.palette.background.default; },
                } }),
            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", justifyContent: "flex-end", sx: {
                    display: value === '' ? 'none' : 'flex',
                } },
                color === 'success' && React.createElement(Check, { fontSize: "small", color: "success" }),
                React.createElement(Typography, { variant: "body2", color: color + ".main" }, scoreTranslation || ''),
                color !== 'success' && errorMessages.length > 0 && (React.createElement(Tooltip, { title: React.createElement(List, { sx: { my: 0, ml: 2.5, listStyleType: 'disc' } }, errorMessages) },
                    React.createElement(InfoOutlined, { fontSize: "small", color: color })))))));
};

export { PasswordStrengthProgress as default };
